<template>
  <div>
    <i
      class="fa fa-spin fa-circle-o-notch"
      v-if="loading"
    />
    <div
      class="form-group"
      v-else
    >
      <p class="form-text">
        <span v-if="integration.id && ! success">
          {{ __('Erro ao conectar a API, atualize esta página ou') }}
          <a
            href="#"
            @click.prevent="updating = ! updating"
          >{{ __('clique aqui e adicione sua url e/ou o token novamente') }}</a>.</span><span v-if="integration.id && success">
          {{ __('Integração configurada. Caso queira alterar') }}
          <a
            href="#"
            @click.prevent="updating = ! updating"
          >{{ __('clique aqui') }}</a>.</span><span v-if="! integration.id">{{ __('Para configurar a integração com a Vista adicione sua url e o token abaixo e clique em salvar') }}.</span>
      </p>
      <form
        @submit.prevent="save()"
        v-if="! integration.id || updating"
      >
        <div class="row">
          <div class="col-7">
            <label class="lg">{{ __('URL do cliente') }}</label>
            <p>
              <input
                class="form-control"
                type="url"
                v-model="config.options.host"
                required="required"
              >
            </p>
          </div>
          <div class="col-5">
            <label class="lg">Token</label>
            <p>
              <input
                class="form-control"
                type="text"
                v-model="config.token"
                :placeholder="tokenPlaceholder"
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <p>
              <button
                class="btn btn-sm btn-box mr-1"
                type="button"
                @click.prevent="remove()"
                v-if="integration.id"
              >
                {{ __('Excluir') }}
              </button>
              <button
                class="btn btn-sm btn-box"
                type="submit"
                :disabled="disabled"
              >
                {{ __('Salvar') }}
              </button>
            </p>
          </div>
        </div>
        <p class="form-text">
          {{ __('Você deve solicitar através de um chamado na Central de Serviços do') }}
          <a
            href="http://novovista.com.br/"
            target="_blank"
          >{{ __('Novo Vista') }}.</a>
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import Integrations from '../../mixins/integrations';

export default {
  mixins: [Integrations],

  data () {
    return {
      config: {
        options: {
          host: '',
        },
      },
      integration: {
        name: 'vista',
      },
    };
  },

  computed: {
    disabled () {
      return this.config.token.length < 32 && ! this.integration.id;
    },
  },
};
</script>
